import React, { useEffect } from "react"
import { Script } from "gatsby"

const HtlScript = ({ targetingOptions = {}, onLoad = () => {} }) => {
  const isProd = process.env.GATSBY_LOCAL_SITE?.match(/www\.mindbodygreen\.com/)

  const pushHtlCmd = (cmd) => {
    window.htlbid = window.htlbid || {}
    window.htlbid.cmd = window.htlbid.cmd || []
    window.htlbid.cmd.push(cmd)
  }

  useEffect(() => {
    let isTTD = false
    const { search } = location
    if (search) {
      const urlParams = new URLSearchParams(search)
      isTTD = urlParams.get("utm_source") === "ttd"
    }
    const isSearch = Boolean(document.referrer?.match(/^https:\/\/www\.(google|bing)\.com/))

    pushHtlCmd(() => {
      if (!window.htlbid) {
        console.error("HTL not initialized!")
        return
      }

      window.htlbid.setTargeting("is_testing", isProd ? "no" : "yes")
      window.htlbid.setTargeting("ttd", `${isTTD}`)
      window.htlbid.setTargeting("search_referer", isSearch)
      if (Object.keys(targetingOptions).length > 0) {
        Object.keys(targetingOptions).forEach((key) => {
          window.htlbid.setTargeting(key, targetingOptions[key])
        })
      }

      window.htlbid.cmd.push(() => {
        window.htlbid.layout("universal")
      })
    })
  }, [isProd, targetingOptions])

  const handleScriptLoad = () => {
    onLoad()
  }

  const scriptSrc = isProd
    ? "https://htlbid.com/v3/mindbodygreen.com/htlbid.js"
    : "https://htlbid.com/stage/v3/mindbodygreen.com/htlbid.js"

  return (
    <Script
      src={scriptSrc}
      type="text/javascript"
      onLoad={handleScriptLoad}
      onError={(e) => console.error("HTL Script failed to load:", e)}
    />
  )
}

export default React.memo(HtlScript)
